import React from 'react';

// @ts-nocheck
import * as styles from './styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { PopupTypes } from '@cobliteam/store/src/Popup';

import { NotificationsIcon } from '@cobliteam/base-components';

import { ExportAlertModalContainer } from '../ExportAlertModal/ExportAlertModalContainer';
import { IncidentsPopupContainer } from '../IncidentsPopup';

export interface IncidentsAndTripsProps {
  openPopup: PopupTypes;
  onClickPopup: (popupType: PopupTypes) => void;
  onClickAway: () => void;
}

export interface IncidentsAndTripsState {
  isIncidentsExportModalOpen: boolean;
}

export class IncidentsAndTrips extends React.Component<
  IncidentsAndTripsProps,
  IncidentsAndTripsState
> {
  constructor(props: IncidentsAndTripsProps) {
    super(props);

    this.state = {
      isIncidentsExportModalOpen: false,
    };
  }

  private handlePopupClick = (popupType: PopupTypes) => {
    const { openPopup, onClickPopup } = this.props;

    const popup = openPopup === popupType ? PopupTypes.NONE : popupType;
    onClickPopup(popup);
  };

  private handleExportClick = () => {
    this.setState({
      isIncidentsExportModalOpen: true,
    });
  };

  private handleModalClose = () => {
    this.setState({
      isIncidentsExportModalOpen: false,
    });
  };

  public render = () => {
    const { openPopup, onClickAway } = this.props;
    const { isIncidentsExportModalOpen } = this.state;

    return (
      <>
        <div className={styles.incidentsAndTrips}>
          <ClickAwayListener
            onClickAway={onClickAway}
            mouseEvent={openPopup === PopupTypes.INCIDENTS ? 'onClick' : false}
          >
            <div>
              <div
                className={styles.button}
                onClick={() => this.handlePopupClick(PopupTypes.INCIDENTS)}
              >
                <NotificationsIcon className={styles.notificationsIcon} />
              </div>

              {openPopup === PopupTypes.INCIDENTS && (
                <div className={styles.popupWrapper}>
                  <IncidentsPopupContainer
                    handleExportClick={this.handleExportClick}
                  />
                </div>
              )}
            </div>
          </ClickAwayListener>
        </div>

        {isIncidentsExportModalOpen && (
          <ExportAlertModalContainer onCancel={this.handleModalClose} />
        )}
      </>
    );
  };
}
